<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    window.location.replace('https://jjzm.k12top.com/#/login')
  }
}
</script>
